import { JSX, useEffect, useState } from 'react';
import ArrowUp from '../../assets/images/icons/arrow-up.svg';

type PaginationProps = {
  numberOfVisiblePages: number;
  itemsPerPage: number;
  numberOfItems: number;
  index: number;
  // eslint-disable-next-line no-unused-vars
  setIndex: (a: number) => void;
};

const Pagination = (props: PaginationProps): JSX.Element => {
  if (!props) return <></>;

  const [totalPages, setTotalPages] = useState<number>(0);

  useEffect(() => {
    setTotalPages(Math.ceil(props.numberOfItems / props.itemsPerPage));
  }, [props.numberOfItems, props.itemsPerPage]);

  const handlePrevious = () => {
    if (props.index > 0) {
      props.setIndex(props.index - 1);
    }
  };

  const handleNext = () => {
    if (props.index + 1 < totalPages) {
      props.setIndex(props.index + 1);
    }
  };

  const middlePages: number[] = [];
  const currentPage = props.index + 1;
  const visible = props.numberOfVisiblePages;

  let start = currentPage;
  let end = currentPage + visible - 1;

  if (end >= totalPages) {
    end = totalPages;
    start = end - visible + 1;
  }

  start = Math.max(2, start);

  for (let i = start; i <= end; i++) {
    middlePages.push(i);
  }

  return (
    <div className="pagination">
      <ul>
        <li onClick={handlePrevious}>
          <a className="pagination-btn previous">
            <ArrowUp className="icon icon-arrow-up" />
          </a>
        </li>

        <li
          key={1}
          className={currentPage === 1 ? 'active' : ''}
          onClick={() => props.setIndex(0)}
        >
          <a href="#">1</a>
        </li>

        {middlePages.length > 0 && middlePages[0] > 2 && (
          <li key="left-ellipsis">
            <span>...</span>
          </li>
        )}

        {middlePages.map(page => (
          <li
            key={page}
            className={currentPage === page ? 'active' : ''}
            onClick={() => props.setIndex(page - 1)}
          >
            <a href="#">{page}</a>
          </li>
        ))}

        {middlePages.length > 0 &&
          middlePages[middlePages.length - 1] < totalPages - 1 && (
            <li key="right-ellipsis">
              <span>...</span>
            </li>
          )}

        {totalPages > 1 && !middlePages.includes(totalPages) && (
          <li
            key={totalPages}
            className={currentPage === totalPages ? 'active' : ''}
            onClick={() => props.setIndex(totalPages - 1)}
          >
            <a href="#">{totalPages}</a>
          </li>
        )}

        <li onClick={handleNext}>
          <a className="pagination-btn next">
            <ArrowUp className="icon icon-arrow-up" />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
